import { render, staticRenderFns } from "./Nabar.vue?vue&type=template&id=a878b2c8"
import script from "./Nabar.vue?vue&type=script&lang=js"
export * from "./Nabar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports